import z from 'zod'

import { groupLearningAssignmentProperties } from './BaseModels'

export const groupLearningAssignmentParser = z.object(groupLearningAssignmentProperties)

export type GroupLearningAssignment = z.infer<typeof groupLearningAssignmentParser>
